import React, { useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import UiSelect from "../../common/UiSelect";
import UiSearchInputField from "../../common/UiSearchInputField";
import BatchLabelSearchField from "./BatchLabelSearchField";
import { tablePageToolbarStyles } from "../../common/tableTheme";

export type SearchMode = "all" | "labels";

interface Props {
  classes: Record<string, string>;
  searchTerm: string;
  onSearch: (term: string) => void;
}

const BatchSearchBar = ({
  classes,
  searchTerm,
  onSearch,
}: Props) => {
  const [mode, setMode] = useState<SearchMode>("all");

  const handleModeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setMode(e.target.value as SearchMode);
  };

  return (
    <div className={classes.searchArea}>
      <div className={classes.searchGroup}>
        <UiSelect
          name="searchMode"
          value={mode}
          onChange={handleModeChange}
          variant="modern"
          inGroup
          className={classes.searchModeInGroup}
        >
          <option value="all">Tout</option>
          <option value="labels">Labels</option>
        </UiSelect>
        <div className={classes.searchFieldInGroup}>
          {mode === "all" ? (
            <UiSearchInputField
              searchString={searchTerm}
              setSearchString={onSearch}
              variant="modern"
              inGroup
            />
          ) : (
            <BatchLabelSearchField
              searchTerm={searchTerm}
              onSearch={onSearch}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default withStyles(tablePageToolbarStyles as any)(BatchSearchBar);
